import React, { useState } from "react";
import {
    Grid,
    TextField,
    Button,
    Typography,
    Modal,
    Box,
    CircularProgress,
    IconButton,
} from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { Close } from "@mui/icons-material";
import axios from "axios";
import endpoints from "../../../endpoint";

const validationSchema = Yup.object({
    title: Yup.string().required("Title is required"),
    description: Yup.string()
        .min(20, "Description must be at least 20 characters")
        .required("Description is required"),
});

const EditAnalyst = ({ open, onClose, strategy }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (values, { setSubmitting }) => {
        setIsSubmitting(true);
        try {
            const response = await axios.put(`${endpoints.serverBaseUrl}api/market/` + strategy._id, {
                title: values.title,
                description: values.description,
            }, {
                withCredentials: true,
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem('token')}`
                }
            });

            toast.success("Analyst updated successfully!");
            onClose(); // Close modal on success
        } catch (error) {
            toast.error("Failed to update analyst. Please try again.");
        } finally {
            setIsSubmitting(false);
            setSubmitting(false);
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 2,
                    borderRadius: 2,
                    width: "90%",
                    maxWidth: 500,
                    maxHeight: "80vh",
                    overflowY: "auto",
                }}
            >
                <IconButton sx={{ position: "absolute", top: 8, right: 8 }} onClick={onClose}>
                    <Close />
                </IconButton>
                <Typography variant="h5" gutterBottom sx={{ textAlign: "center" }}>
                    Edit Analyst
                </Typography>
                <Formik
                    initialValues={{
                        title: strategy?.title || "",
                        description: strategy?.description || "",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ isValid, dirty }) => (
                        <Form>
                            <Grid container spacing={2} p={2}>
                                <Grid item xs={12}>
                                    <Field
                                        as={TextField}
                                        fullWidth
                                        label="Title"
                                        name="title"
                                        required
                                    />
                                    <ErrorMessage name="title" component="div" style={{ color: "red" }} />
                                </Grid>

                                <Grid item xs={12}>
                                    <Field
                                        as={TextField}
                                        fullWidth
                                        label="Description"
                                        name="description"
                                        required
                                        multiline
                                        rows={4}
                                    />
                                    <ErrorMessage name="description" component="div" style={{ color: "red" }} />
                                </Grid>

                                <Grid item xs={12}>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                        disabled={isSubmitting || !(isValid && dirty)}
                                    >
                                        {isSubmitting ? <CircularProgress size={24} /> : "Update Analyst"}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </Box>
        </Modal>
    );
};

export default EditAnalyst;
